/**
 * 画面の上部までスクロール
 */
const scrollToTop = () => {
  window.scrollTo({ top: 0 });
};

export default scrollToTop;
